window.onload = function() {

    // to open menu from burger when mobile
console.log('openable')
const burger = document.querySelector('.home-burger');
const menu = document.querySelector('.home-burger-menu');

    if (burger) {
        console.log("burger")
        burger.addEventListener('click', function(){
            console.log("wech")
            menu.classList.toggle('show');
            burger.firstElementChild.classList.toggle('fa-bars');
            burger.firstElementChild.classList.toggle('fa-times');
        })
    }
}